import { defineComponent as _defineComponent } from 'vue';
import { translate } from '@/i18n';
import { useSettingsStore } from '@/store/modules/settings';

import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'VabSubMenu',
  props: {
    itemOrMenu: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const settingsStore = useSettingsStore();
    const {
      theme
    } = storeToRefs(settingsStore);
    const __returned__ = {
      settingsStore,
      theme,
      get translate() {
        return translate;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});